import { createTreeInsertionController } from './InsertionSharedCode';

// Export AVL controller (isAVL = true)
export default createTreeInsertionController(true);